export const ARTIFACT_QUERY_PARAM = 'mode';

export enum ArtifactType {
  Entry = 'entry',
  Printable = 'print',
  Experience = 'experience',
  Planner = 'planner',
  Schools = 'schools',
}

export const isArtifactType = (value: string): value is ArtifactType => {
  const validTypes: string[] = Object.values(ArtifactType);
  return validTypes.includes(value);
};
